import { AxiosRequestConfig, AxiosResponse, AxiosResponseHeaders } from 'axios'

import baseClient from 'http-client/index'

// Function to perform a GET request
async function get<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
  const response: AxiosResponse<T> = await baseClient.get(url, config)
  return response.data
}

// Function to perform a POST request
async function post<T>(
  url: string,
  data?: any,
  config?: AxiosRequestConfig
): Promise<T> {
  const response: AxiosResponse<T> = await baseClient.post<T>(url, data, config)
  return response.data
}

// Function to perform a PUT request
async function put<T>(
  url: string,
  data: any,
  config?: AxiosRequestConfig
): Promise<T> {
  const response: AxiosResponse<T> = await baseClient.put<T>(url, data, config)
  return response.data
}

async function patch<T>(
  url: string,
  data: any,
  config?: AxiosRequestConfig
): Promise<T> {
  const response: AxiosResponse<T> = await baseClient.patch(url, data, config)
  return response.data
}

// Function to perform a DELETE request
async function remove<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
  const response: AxiosResponse<T> = await baseClient.delete<T>(url, config)
  return response.data
}

export interface DownloadResult<T> {
  data: T
  headers: AxiosResponseHeaders
}

export { get, patch, post, put, remove }
